/*
 * -----------------------------------------------
 * Common: LP共通スライダー（クラス自動検出方式）
 *
 * HTMLにクラスを付けるだけでスライダーが動きます。
 * JSファイルへの追記は不要です。
 *
 * パターンA: 矢印のみ        → class="js-common-slider"
 * パターンB: 矢印 + ページャー → class="js-common-dots-slider"
 *
 * data属性でオプション上書き可能:
 *   data-speed="400"
 *   data-infinite="true"
 *   data-autoplay="true"
 *   data-autoplay-speed="3000"
 * -----------------------------------------------
 */
const initCommonSliders = function() {

	const wrapper = $('.js-wrapper');

	const defaults = {
		speed: 800,
		dots: false,
		infinite: false,
		variableWidth: true,
		lazyLoad: 'progressive',
		prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
		nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
	};

	wrapper.on('load', function(){

		$('.js-common-slider, .js-common-dots-slider').each(function(){
			const $el = $(this);
			const hasDots = $el.hasClass('js-common-dots-slider');

			const overrides = {};
			if ($el.data('speed'))          overrides.speed = $el.data('speed');
			if ($el.data('infinite'))        overrides.infinite = $el.data('infinite') === true || $el.data('infinite') === 'true';
			if ($el.data('autoplay'))        overrides.autoplay = $el.data('autoplay') === true || $el.data('autoplay') === 'true';
			if ($el.data('autoplay-speed'))  overrides.autoplaySpeed = $el.data('autoplay-speed');

			const settings = $.extend({}, defaults, { dots: hasDots }, overrides);
			$el.slick(settings);
		});
	});
}


/*
 * ranking slider
 */
const rankingSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const ranking = $('.js-ranking-slider');

		ranking.slick({
			speed: 800,
			infinite: false,
			slidesToShow: 1.1,
			lazyLoad: 'ondemand',
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}


/*
 * problemType slider
 */
const problemTypeSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const problemType = $('.js-problem-slider');

		problemType.slick({
			speed: 800,
			infinite: false,
			slidesToShow: 1.6,
			lazyLoad: 'ondemand',
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}

/*
 * price slider
 */
const priceSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const price = $('.js-price-slider');

		price.slick({
			speed: 800,
			infinite: false,
			//variableWidth: true,
			slidesToShow: 1.1,
			lazyLoad: 'ondemand',
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}


/*
 * steps slider
 */
const stepsSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const steps = $('.js-steps-slider');

		steps.slick({
			speed: 800,
			infinite: false,
			slidesToShow: 1.1,
			lazyLoad: 'ondemand',
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}


/*
 * clinic slider
 */
const clinicSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const clinic = $('.js-clinic-slider');

		clinic.slick({
			speed: 800,
			dots: true,
			infinite: false,
			lazyLoad: 'ondemand',
			slidesToShow: 1.04,
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}



/*
 * artist slider
 */
const artistSlider = function() {
	const wrapper = $('.js-wrapper');

	const setUniformProfileHeight = function() {
		const profiles = $('.p-lp-artist__item-profile');
		const cases = $('.p-lp-artist__item-case');
		let maxProfileHeight = 0;
		let maxCaseHeight = 0;

		// 高さリセット
		profiles.css('height', 'auto');
		cases.css('height', 'auto');

		// 最大高さを取得
		profiles.each(function() {
			maxProfileHeight = Math.max(maxProfileHeight, $(this).outerHeight());
		});
		cases.each(function() {
			maxCaseHeight = Math.max(maxCaseHeight, $(this).outerHeight());
		});

		// 最大値で揃える
		profiles.css('height', maxProfileHeight + 'px');
		cases.css('height', maxCaseHeight + 'px');
	};

	wrapper.on('load', function(){
		const artistList = $('.js-artist-slider');
		const counter = $('.js-artist-counter');
		const current = counter.find('.current');
		const total = counter.find('.total');

		artistList.on('init reInit afterChange', function(event, slick, currentSlide){
			let i = (typeof currentSlide === 'undefined' ? 0 : currentSlide) + 1;
			current.text(i);
			total.text(slick.slideCount);

			// スライド更新時にも高さ再調整
			setUniformProfileHeight();
		});

		artistList.slick({
			speed: 800,
			dots: false,
			//lazyLoad: 'ondemand',
			infinite: false,
			slidesToShow: 1.1,
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});

		// 初期化後に高さ調整
		artistList.on('setPosition', function() {
			setUniformProfileHeight();
		});
	});

	$(window).on('resize', function() {
		setUniformProfileHeight();
	});
};



/*
 * about me slider
 */
const singleArtistAboutMe = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const caseList = $('.js-artist-single-about-me-slider');

		caseList.slick({
			speed: 800,
			dots: true,
			lazyLoad: 'ondemand',
			arrows: false,
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}



/*
 * choice table (not slick)
 */
const choiceTableScroll = function() {
	const $container = $('.p-lp-choice__table-image');
	const $nextButton = $container.next('.slick__next');

	if ($container.length === 0 || $nextButton.length === 0) return;

	$nextButton.show();
	$container.on('scroll', function() {
		const scrollLeft = this.scrollLeft;
		//const scrollWidth = this.scrollWidth;
		const scrollWidth = 768;
		const containerWidth = this.clientWidth;

		if (scrollLeft + containerWidth >= scrollWidth - 1) {
			$nextButton.hide();
		} else {
			$nextButton.show();
		}
	});


	$nextButton.on('click', function() {
		$container.animate({
			scrollLeft: '+=' + 200
		}, 300);
	});

	$container.trigger('scroll');
};


/*
 * lift ideal slider
 */
const liftIdealSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const liftIdeal = $('.js-lift-ideal-slider');

		liftIdeal.slick({
			speed: 800,
			infinite: true,
			dots: true,
			lazyLoad: 'ondemand',
			variableWidth: true,
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}


/*
 * lift reason slider
 */
const liftReasonSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const liftReason = $('.js-lift-reason-slider');

		liftReason.slick({
			speed: 800,
			infinite: true,
			lazyLoad: 'ondemand',
			variableWidth: true,
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}


/*
 * lift step slider
 */
const liftStepSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const liftStep = $('.js-lift-step-slider');

		liftStep.slick({
			speed: 800,
			infinite: false,
			lazyLoad: 'ondemand',
			variableWidth: true,
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}


/*
 * lip case slider
 */
const lipCaseSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const lipCase = $('.js-lip-case-slider');

		lipCase.slick({
			speed: 800,
			dots: true,
			infinite: true,
			lazyLoad: 'progressive',
			variableWidth: true,
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}


/*
 * lip step slider
 */
const lipStepSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const lipStep = $('.js-lip-step-slider');

		lipStep.slick({
			speed: 800,
			infinite: false,
			lazyLoad: 'progressive',
			variableWidth: true,
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}


/*
 * case slider (artist single page)
 */
const caseSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const caseList = $('.js-case-slider');

		caseList.slick({
			speed: 800,
			dots: true,
			lazyLoad: 'ondemand',
			arrows: false,
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}



/*
 * nikibi intro slider
 */
const nikibiIntroSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const nikibiIntro = $('.js-nikibi-intro-slider');

		nikibiIntro.slick({
			speed: 800,
			dots: true,
			infinite: false,
			lazyLoad: 'progressive',
			variableWidth: true,
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}


/*
 * nikibi point01 slider
 */
const nikibiPoint01Slider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const nikibiPoint01 = $('.js-nikibi-point01-slider');

		nikibiPoint01.slick({
			speed: 800,
			dots: true,
			infinite: true,
			lazyLoad: 'progressive',
			variableWidth: true,
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}


/*
 * artmaketerrace newpost slider
 */
const artmakeTerraceTopNewpostSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function() {
		const $slider = $('.js-artmaketerrace-top-newpost-slider');
		$slider.slick({
			speed: 800,
			dots: true,
			infinite: false,
			lazyLoad: 'ondemand',
			slidesToShow: 1.1,
			arrows: false,
		});
	});
};



/*
 * artmaketerrace clinic slider
 */
const artmaketerraceClinicSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){
		const clinic = $('.js-artmaketerrace-clinic-slider');
		clinic.slick({
			speed: 800,
			dots: true,
			infinite: false,
			lazyLoad: 'ondemand',
			slidesToShow: 1.2,
			arrows: false,
		});
	});
}

/*
 * case recommend slider
 */
const caseRecommendSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){
		const recommend = $('.js-case-recommend-slider');

		recommend.on('init', function(event, slick){
			// 初期化完了後にフェードイン
			setTimeout(function(){
				recommend.addClass('slick-initialized');
			}, 50);
		});

		recommend.slick({
			speed: 800,
			infinite: false,
			slidesToShow: 1.3,
			lazyLoad: 'ondemand',
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}

/*
 * case related slider
 */
const caseRelatedSlider = function() {

	const wrapper = $('.js-wrapper');

	wrapper.on('load', function(){

		const related = $('.js-case-related-slider');

		if (related.length === 0) {
			return;
		}

		related.on('init', function(event, slick){
			// 初期化完了後にフェードイン
			setTimeout(function(){
				related.addClass('slick-initialized');
			}, 50);
		});

		related.slick({
			speed: 800,
			infinite: false,
			slidesToShow: 1.2,
			lazyLoad: 'ondemand',
			prevArrow: '<button class="slick__prev slick__arrow" aria-label="前へ" type="button"></button>',
			nextArrow: '<button class="slick__next slick__arrow" aria-label="次へ" type="button"></button>',
		});
	});
}

/*
* init
*/
$(function() {
	rankingSlider();
	priceSlider();
	problemTypeSlider();
	stepsSlider();
	clinicSlider();
	artistSlider();
	singleArtistAboutMe();
	caseSlider();
	choiceTableScroll();
	liftIdealSlider();
	liftReasonSlider();
	liftStepSlider();
	lipCaseSlider();
	lipStepSlider();
	nikibiIntroSlider();
	nikibiPoint01Slider();
	artmakeTerraceTopNewpostSlider();
	artmaketerraceClinicSlider();
	caseRecommendSlider();
	caseRelatedSlider();

	// LP共通スライダー（クラス自動検出）
	initCommonSliders();
});
